const PAYMENT_ERROR_RESULT = {
  error: 'error',
  success: 'success',
};

/**
 * Entry point for the payment method flow.
 * This is used to track the source of the flow in Mixpanel.
 */
const ENTRY_POINT = {
  insurance: 'insurance',
  myAccount: 'my account',
};

export {
  ENTRY_POINT,
  PAYMENT_ERROR_RESULT,
};
